var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-btn',{staticClass:"rounded-0 mt-0",attrs:{"variant":"light","block":"","size":_vm.$screen.lg ? 'lg' : 'sm'},on:{"click":_vm.inviteUser}},[_c('div',[_c('font-awesome-icon',{attrs:{"icon":"fa-duotone fa-share","size":"lg"}})],1),_vm._v(" "+_vm._s(_vm.$t("Share"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }